export default __webpack_public_path__ + "static/media/apizee.f1d1421f.png";